"use client";
import { callApi } from "../util/superAgentUtil";

/**
 * God Mode API client.
 *
 * These calls deliberately pass `firebase` as undefined so callApi does not
 * append a centerId — an operator is not a member of any center, and the
 * operator-only endpoints are resolved from the Auth0 token alone.
 */

/** Is the signed-in account on the operator allowlist? Safe to call for everyone. */
async function fetchStatus(): Promise<any> {
    return callApi(undefined, "get", "bookingoApi/godMode/status", {});
}

async function fetchCenters(search?: string, limit = 100): Promise<any> {
    const query = new URLSearchParams();
    if (search) query.set("search", search);
    query.set("limit", String(limit));
    return callApi(undefined, "get", `bookingoApi/godMode/centers?${query.toString()}`, {});
}

/** Opens a read-only session and returns { session, schoolConfig, teacher }. */
async function startSession(centerId: string, reason: string): Promise<any> {
    return callApi(
        undefined,
        "post",
        `bookingoApi/godMode/session?centerId=${encodeURIComponent(centerId)}`,
        { reason },
    );
}

async function elevateSession(sessionId: string, reason: string): Promise<any> {
    return callApi(
        undefined,
        "post",
        `bookingoApi/godMode/session/${encodeURIComponent(sessionId)}/elevate`,
        { reason },
    );
}

async function endSession(sessionId: string, reason?: string): Promise<any> {
    return callApi(
        undefined,
        "post",
        `bookingoApi/godMode/session/${encodeURIComponent(sessionId)}/end`,
        { reason: reason || "Ended by operator" },
    );
}

async function fetchSessionStatus(sessionId: string): Promise<any> {
    return callApi(
        undefined,
        "get",
        `bookingoApi/godMode/session/${encodeURIComponent(sessionId)}`,
        {},
    );
}

export const godModeApi = {
    fetchStatus,
    fetchCenters,
    startSession,
    elevateSession,
    endSession,
    fetchSessionStatus,
};
